import React from 'react';
import { GetUserProfile } from '../../security';
import { analytics } from '@atlassian/temp-analytics';

export default function AnalyticsInit() {
  const userProfile = GetUserProfile();

  const atlassianAccountIdProvider = async () => {
    if (userProfile && userProfile.atlassianAccountId) {
      return userProfile.atlassianAccountId;
    }
  };

  const rolesProvider = async () => {
    if (userProfile && userProfile.roles) {
      return userProfile.roles;
    }
  };

  React.useEffect(() => {
    // @ts-ignore
    analytics.setup(() => atlassianAccountIdProvider());
    analytics.startUIViewedEvent();
    // @ts-ignore
    analytics.setupRoles(() => rolesProvider());
  }, [userProfile]);
  return <></>;
}
